const Conditional = props => {
  const { show, children } = props
  return show ? children : null
}

export default Conditional
